import { combineReducers } from "redux-immutable";

import config from "./config/index";
import impersonation from "./impersonation/index";
import errors from "./errors/index";

const rootReducer = combineReducers({
  [config.constants.NAME]: config.reducer,
  [errors.constants.NAME]: errors.reducer,
  [impersonation.constants.NAME]: impersonation.reducer,
});

export default rootReducer;
